import React, { useState } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import '../App.css';
import logo from "../logo-main.png"

function DeleteAccount() {

    const [email, setEmail] = useState("");

    const handleChange = (event) => {
        setEmail(event.target.value);
    };

    const handleDelete = async () => {
        if (!email) {
            alert("Please enter your email.");
            return;
        }
    
        try {
            const response = await fetch('https://nomad-backend-9ei8.onrender.com/api/v1/profiles/' + email + '/deleteProfile/email', {
                method: 'DELETE', 
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (response.ok) {
                const data = await response.json();
                alert(`Account deleted: ${data.message}`);
            } else {
                const errorData = await response.json();
                alert(`Error: ${errorData.message}`);
            }
    
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to delete account. Please try again.');
        }
    };

    return (
        <div className="App" style={{ height: "100vh"}}>
            <img src={logo} style={{ width: "500px", margin: "40px"}} alt="nomad log. 3 peak snow covered mountains with the text nomad to the right in all lower case letters."/>
                <h1 className="header">Delete Account & Data</h1>
                <div className="content">
                    <p>Note: This action is perminant and will delete your nomad account and associated data.</p>
                    <p style={{ fontSize: "20px", marginBottom: "2px"}}>* required</p>
                    <div style={{  display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>
                        <TextField
                            id="standard-basic"
                            label="Email*"
                            variant="standard"
                            value={email}
                            onChange={handleChange}
                        />
                        <Button variant="contained" onClick={handleDelete}>Delete Account</Button>
                    </div>
                </div>
        </div>
      )
}

export default DeleteAccount